import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.135 43.383a1 1 0 0 0 1.333.472A22 22 0 0 0 47 23.991 22 22 0 0 0 34.403 4.096a1 1 0 0 0-.856 1.808A20 20 0 0 1 45 23.991a20 20 0 0 1-11.394 18.06 1 1 0 0 0-.471 1.332Zm-1.892-4.487a1 1 0 0 0 1.38.31A17.985 17.985 0 0 0 41 23.99c0-6.294-3.258-12.03-8.504-15.294a1 1 0 0 0-1.056 1.698c4.665 2.903 7.56 8 7.56 13.596 0 5.55-2.846 10.61-7.448 13.525a1 1 0 0 0-.31 1.38Zm-.522-4.83a1 1 0 1 1-1.39-1.439A11.96 11.96 0 0 0 33 23.991a11.96 11.96 0 0 0-3.732-8.697 1 1 0 0 1 1.378-1.45A13.96 13.96 0 0 1 35 23.992a13.96 13.96 0 0 1-4.28 10.075ZM1.037 25.364a7 7 0 0 0 6.99 6.623h3.478l1.397 1.578a61.113 61.113 0 0 0 7.49 7.14l1.152.925a3 3 0 0 0 4.866-2.064c.394-4.278.59-9.47.59-15.579 0-6.112-.196-11.305-.59-15.583a3 3 0 0 0-4.864-2.066l-1.1.883a60.546 60.546 0 0 0-7.397 7.03l-1.542 1.736h-3.48a7 7 0 0 0-6.99 6.622 25.53 25.53 0 0 0 0 2.755ZM11 17.987H8.027a5 5 0 0 0-4.993 4.73 23.527 23.527 0 0 0 0 2.54 5 5 0 0 0 4.993 4.73H11v-12Zm2-.67v13.341l1.4 1.581a59.109 59.109 0 0 0 7.244 6.906l1.153.926a1 1 0 0 0 1.622-.688c.387-4.21.581-9.343.581-15.396 0-6.055-.194-11.189-.582-15.4a1 1 0 0 0-1.62-.689l-1.102.883a58.546 58.546 0 0 0-7.152 6.798L13 17.317Z",
    fill: "currentColor"
  }));
};

var SvgSoundHigh = styled(SvgComponent).withConfig({
  displayName: "SoundHigh__SvgSoundHigh",
  componentId: "sc-1pzquzl-0"
})(["", " ", ""], size, color);
export default SvgSoundHigh;